/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConcernedSubjectContactDto } from './concernedSubjectContactDto.model';


export interface ListResponseConcernedSubjectContactDto { 
    itemCount?: number;
    items?: Array<ConcernedSubjectContactDto>;
    params?: { [key: string]: any; };
}

